var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.29289,2.292893C8.105360000000001,2.105357,7.851,2,7.58579,2L3,2C2.447715,2,2,2.447715,2,3L2,10L3,10L3,3L7.58579,3L8.58579,4L13,4L13,13L9,13L9,14L13,14C13.5523,14,14,13.5523,14,13L14,4C14,3.44772,13.5523,3,13,3L9,3L8.29289,2.292893ZM4,5L12,5L12,6L4,6L4,5Z",
    fillRule: "evenodd",
    fill: "#222222",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.632815,11.810226484375L3.972732,10.150146484375L3.265625,10.857253484375L4.9121749999999995,12.503696484375L3.265625,14.150146484375L3.972732,14.857256484375L5.632815,13.197176484375L7.292895,14.857256484375L8.000005,14.150146484375L6.353445,12.503696484375L8.000005,10.857253484375L7.292895,10.150146484375L5.632815,11.810226484375Z",
    fillRule: "evenodd",
    fill: "#222222",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchived);
export default __webpack_public_path__ + "static/media/unarchived.fadfa76b363c95c6ac92c9fb72bf0e67.svg";
export { ForwardRef as ReactComponent };